'use strict';
var searchPartMixin = require('../modules/mixins/searchpart.mixin');

Odigeo.defineWidget('flight_type_search_manager', Odigeo.Widget.extend({

    modelClass: Odigeo.Model.extend(searchPartMixin.extend({
        defaults: {
            type: 'roundTrip',
        },
    })),

    viewClass: Odigeo.View.extend({
        events: {
            'change input[type=radio]': 'onChange',
        },

        selectors: {
            input: '.flight_type_selector_input',
            multipleDestination: '.oneline_flight_type_multiple_trip',
        },

        init: function() {
            this.render();
            this.listenTo(this.model, 'sync:fetch', this.render);
        },

        render: function() {
            var flightType = this.model.get('type');
            var allowMultipleDestination = this.widget.options.allowMultipleDestination === 'true';

            this.$cachedSelectors.multipleDestination.toggleClass('odf-hidden', !allowMultipleDestination);
            this.$cachedSelectors.input.filter('[value=' + flightType + ']').prop('checked', true);
            return this;
        },

        onChange: function(event) {
            var flightsType = event.currentTarget.value;
            if (Odigeo._.includes(['oneWayTrip', 'roundTrip'], flightsType)) {
                Odigeo.trigger('OneLinerMultiDestination:changeLegsMD', 1);
            }
            this.model.save({'type': flightsType});
        },
    }),
}));
